module.exports = __webpack_public_path__ + "static/media/annoying-weight-gain-map.84627943.png";